import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login'
import Live from '@/views/Live'
import Q from '@/views/Q'
import Cover from '@/views/Cover'
import Sync from '@/views/Sync'
import Err from '@/views/Err'
import Report from '@/views/Report'

Vue.use(VueRouter)

const routes = [
  {
    path: '/DisIndex',
    name: 'DisIndex',
    component: () => import(/* webpackChunkName: "dis_index" */ '@/views/distributor/DisIndex'),
    meta: { title: '我的', member_type: 3 },
  },
  {
    path: '/DisStudy',
    name: 'DisStudy',
    component: () => import(/* webpackChunkName: "dis_study" */ '@/views/distributor/DisStudy'),
    meta: { title: '学习', member_type: 3 },
  },
  {
    path: '/DisEventDetail/:id',
    name: 'DisEventDetail',
    component: () => import(/* webpackChunkName: "dis_study_event" */ '@/views/support/EventDetail'),
    meta: { title: '学习', member_type: 3 },
  },
  {
    path: '/DisGM',
    name: 'DisGM',
    component: () => import(/* webpackChunkName: "dis_gm" */ '@/views/distributor/DisGM'),
    meta: { title: '团队', member_type: 3 },
  },
  {
    path: '/DisChart',
    name: 'DisChart',
    component: () => import(/* webpackChunkName: "dis_chart" */ '@/views/distributor/DisChart'),
    meta: { title: '数据', member_type: 3 },
  },
  {
    path: '/DisStat/:type',
    name: 'DisStat',
    component: () => import(/* webpackChunkName: "dis_stat" */ '@/views/support/Stat'),
    meta: { title: '统计', member_type: 3 },
  },
  {
    path: '/DisEventStat/:id',
    name: 'DisEventStat',
    component: () => import(/* webpackChunkName: "dis_evstat" */ '@/views/support/EventStat'),
    meta: { title: '活动统计', member_type: 3 },
  },
  {
    path: '/DisCharge',
    name: 'DisCharge',
    component: () => import(/* webpackChunkName: "dis_charge" */ '@/views/distributor/DisCharge'),
    meta: { title: '资源包充值', member_type: 3 },
  },
  {
    path: '/DisChargeRecord',
    name: 'DisChargeRecord',
    component: () => import(/* webpackChunkName: "dis_charge_record" */ '@/views/distributor/DisChargeRecord'),
    meta: { title: '充值记录', member_type: 3 },
  },
  {
    path: '/GMStat/:type',
    name: 'GMStat',
    component: () => import(/* webpackChunkName: "gm_stat" */ '@/views/support/Stat'),
    meta: { title: '统计', member_type: 2 },
  },
  {
    path: '/GMEventStat/:id',
    name: 'GMEventStat',
    component: () => import(/* webpackChunkName: "gm_evstat" */ '@/views/support/EventStat'),
    meta: { title: '活动统计', member_type: 2 },
  },
  {
    path: '/GMEventCustomer/:id',
    name: 'GMEventCustomer',
    component: () => import(/* webpackChunkName: "gm_evstat" */ '@/views/support/EventCustomer'),
    meta: { title: '活动参与记录', member_type: 2 },
  },
  {
    path: '/GMChart',
    name: 'GMChart',
    component: () => import(/* webpackChunkName: "gm_chart" */ '@/views/group_master/GMChart'),
    meta: { title: '群管理数据', member_type: 2 },
  },
  {
    path: '/GMCustomer',
    name: 'GMCustomer',
    component: () => import(/* webpackChunkName: "gm_customer" */ '@/views/group_master/GMCustomer'),
    meta: { title: '会员管理', member_type: 2 },
  },
  {
    path: '/GMStudy',
    name: 'GMStudy',
    component: () => import(/* webpackChunkName: "gm_study" */ '@/views/group_master/GMStudy'),
    meta: { title: '学习', member_type: 2 },
  },
  {
    path: '/GMEventDetail/:id',
    name: 'GMEventDetail',
    component: () => import(/* webpackChunkName: "gm_study_event" */ '@/views/support/EventDetail'),
    meta: { title: '学习', member_type: 2 },
  },
  {
    path: '/GMLive',
    name: 'GMLive',
    component: () => import(/* webpackChunkName: "gm_live" */ '@/views/group_master/GMLive'),
    meta: { title: '欢迎', member_type: 2 },
  },
  {
    path: '/error',
    name: 'Err',
    component: Err,
    meta: { title: '错误' },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { title: '登录' },
  },
  {
    path: '/sync',
    name: 'Sync',
    component: Sync,
    meta: { title: '登录' },
  },
  {
    path: '/live',
    name: 'Live',
    component: Live,
    meta: { title: '欢迎' },
  },
  // {
  //   path: '/Q',
  //   name: 'Q',
  //   component: Q,
  //   meta: { title: '欢迎' },
  // },
  {
    path: '/report',
    name: 'Report',
    component: Report,
    meta: { title: '举报' },
  },
  {
    path: '/report/:page',
    name: 'ReportPage',
    component: Report,
    meta: { title: '举报' },
  },
  {
    path: '/cover',
    name: 'Cover',
    component: Cover,
    meta: { title: '欢迎' },
  },
  {
    path: '/c-event',
    name: 'CusEvent',
    component: () => import(/* webpackChunkName: "cus_event" */ '@/views/W'),
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
